import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zendesk-development',
  templateUrl: './zendesk-development.component.html',
  styleUrls: ['./zendesk-development.component.scss']
})
export class ZendeskDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
